// extracted by mini-css-extract-plugin
module.exports = {"statsCard":"StatsCard_statsCard__U67L3 global_cardHover__VD7I6","blurredBackground":"StatsCard_blurredBackground__d147z","backgroundImage":"StatsCard_backgroundImage__NdxG9"};